import classNames from 'classnames'
import React from 'react'
import s from './UserScreenContent.less'

const UserScreenContent = ({ children }) => <div className={classNames(s.root)}>{children}</div>

export default UserScreenContent
